import { useSearchParams } from 'react-router-dom';
import { Label, TextStyle, duploLightTheme } from '@lannister/duplo';
import { FluentProvider } from "@fluentui/react-components";

import { ReactComponent as SuccessfulIcon} from '../../../assets/icons/success.svg';

import SectionDivider from '../../../Components/Common/sectionDivider';
import PoweredBy from '../../Checkout/poweredBy';
import LoadingView from '../../loadingView';
import usePostPayment from "./usePostPayment";
import InfoRow from './infoRow';
import "./styles.css";

const SuccessfulPaymentView = () => {

    const [searchParams] = useSearchParams();
    const merchantId = searchParams.get('merchant_id');
    const amount = searchParams.get('paid_amount');
    const gatewayTransactionReference = searchParams.get('gateway_transaction_reference');
    const merchantTransactionTeference = searchParams.get('merchant_transaction_reference');

    const { merchantLogo, isLoading, details } = usePostPayment(merchantId, merchantTransactionTeference);

    const ExtraCustomDetails = () => {
        return (
            <>
                {Object.entries(details.extra_custom_details).map(([key, value]) => (
                    <InfoRow key={key} label={key} value={value} />
                ))}
            </>
        );
    };

    return (
        <FluentProvider theme={duploLightTheme}>
            <div className='hero'>
                <div className='header'>
                    <SuccessfulIcon  className='icon'/>
                    <div className='message'>
                        <Label
                            wrap={true}
                            labelText="Payment completed successfully"
                            textStyle={TextStyle.Heading3Semibold} />
                            <Label
                                wrap={true}
                                labelText="Thank you, your payment is confirmed and processed."
                                textStyle={TextStyle.Heading5Regular} />
                    </div>
                </div>

                <SectionDivider />

                {isLoading ? <LoadingView color='#4055FF' /> : <div className='body'>
                    <div className='merchant-row'>
                        {merchantLogo && <img src={merchantLogo} className="merchant-logo" alt="merchant" /> }
                        <div >
                            <Label
                                wrap={true}
                                labelText={details.title}
                                textStyle={TextStyle.Heading6Regular} />
                            <br />
                            <Label
                                labelText={amount}
                                textStyle={TextStyle.Heading5Semibold} />
                        </div>
                    </div>

                    <SectionDivider />

                    { details.description &&
                        <>
                            <div className='description'>
                                <Label 
                                    wrap={true}
                                    labelText={details.description}
                                    textStyle={TextStyle.BaseRegular} />
                            </div>

                            <SectionDivider />
                        </>}

                    <Label 
                        labelText='Invoice Details' textStyle={TextStyle.LargeSemibold} />

                    <InfoRow label='Invoice ID' value={details.merchant_reference ?? merchantTransactionTeference} wrap={true}/>
                    <InfoRow label='Transaction ID' value={gatewayTransactionReference} wrap={true}/>
                    <ExtraCustomDetails />

                    <SectionDivider />
                    
                    <InfoRow label= 'Total' value={`${amount} ${details.currency}`} textStyle={TextStyle.LargeBold} /> 

                </div>}

                <PoweredBy />
            </div>
        </FluentProvider>
    );
}

export default SuccessfulPaymentView;
